import { useMemo, useState } from "react";
import Title from "../../../../../components/dynamicanalysis/Title";
import Grid from "../../../../../components/Grid";
import { usePagination } from "../../../../../hooks";
import { DYNAMIC_ANALYSIS_EMPTY_MESSAGES } from "../consts";
import { RlCloudSandboxSuricataAlertsSchema } from "./RlCloudSandboxSuricataAlertsSchema";
import { SuricataSnortAlert, SuricataSort } from "./types";
import { handleSuricataSort } from "./utils";

const DEFAULT_SORT: SuricataSort = {
  field: "rule",
  direction: "desc"
};

type RlCloudSandboxSuricataAlertsProps = {
  data?: Array<SuricataSnortAlert>;
  reportTitle: string;
};

const RlCloudSandboxSuricataAlerts = ({
  data,
  reportTitle
}: RlCloudSandboxSuricataAlertsProps) => {
  const [sort, setSort] = useState<SuricataSort>(DEFAULT_SORT);

  const hasSuricataAlerts = data && Boolean(data.length);

  const sortedData = useMemo(
    () => handleSuricataSort(data, sort),
    [data, sort]
  );

  const {
    data: paginatedData,
    currentPageData,
    updatePageData
  } = usePagination(sortedData);

  return (
    <>
      <Title headingLevel="h2" title={`Suricata Alerts (${reportTitle})`} />
      {hasSuricataAlerts ? (
        <Grid
          data={paginatedData}
          numPages={currentPageData.numPages}
          schema={RlCloudSandboxSuricataAlertsSchema}
          page={currentPageData.page}
          pageSize={currentPageData.pageSize}
          totalResults={data?.length || 0}
          showPageNumbers
          onPageChange={(value: number, pageSize: number) => {
            updatePageData({ newPage: value, newPageSize: pageSize });
          }}
          sort={sort}
          onSortChange={setSort}
        />
      ) : (
        <b>{DYNAMIC_ANALYSIS_EMPTY_MESSAGES.suricata_alerts}</b>
      )}
    </>
  );
};

export default RlCloudSandboxSuricataAlerts;
